import React from 'react';
import { AssignmentWizardStepProps } from '../types';
import { toAssignmentWizardData, toAssignmentWizardPackagesFormModel } from '../../../mappers/assignmentMapper';
import { useAgent } from '../../../../../hooks/use-agent/useAgent';
import { ExtraPackageConfig } from '../../../../../providers/api/dtos';
import AssignmentWizardPackagesForm, { AssignmentWizardPackagesFormModel } from './AssignmentWizardPackagesForm';
import { getAllowedDoveItPackages } from '../../../../../utils/extra-packages/getAllowedDoveitPackages';

const AssignmentWizardPackages: React.FC<AssignmentWizardStepProps> = ({
  initialData,
  prospect,
  loading = false,
  formRef,
  onSubmit,
}) => {
  const { data: prospectAgent } = useAgent(prospect.agentId);

  const showSPFPackages = React.useMemo(() => prospectAgent?.configuration?.digitalAssignment?.spfEnabled ?? true, [prospectAgent?.configuration?.digitalAssignment?.spfEnabled]);

  const onInternalSubmit = React.useCallback((formValues: AssignmentWizardPackagesFormModel) => {
    const values = toAssignmentWizardData(initialData, formValues, showSPFPackages);

    // TODO: Fix the type in bricks
    const isFormDirty = (formRef?.current as any)?.dirty ?? false;

    onSubmit(values, isFormDirty);
  }, [formRef, initialData, onSubmit, showSPFPackages]);

  const allowedDoveItPackages: ExtraPackageConfig[] = React.useMemo(() => getAllowedDoveItPackages(prospectAgent), [prospectAgent]);

  return (
    <AssignmentWizardPackagesForm
      initialValues={toAssignmentWizardPackagesFormModel(initialData)}
      innerRef={formRef}
      allowedDoveItPackages={allowedDoveItPackages}
      showSPFPackages={showSPFPackages}
      canAdd
      canEdit
      onSubmit={onInternalSubmit}
      loading={loading}
    />
  );
};

export default AssignmentWizardPackages;
